import React, { Component } from "react";
import {withRouter, Link} from 'react-router-dom';
import {inject, observer} from 'mobx-react';
import ReactPaginate from 'react-paginate';

import {PageWrapper} from 'components/PageWrapper';

import HttpClient from 'services/HttpClient';

const CLINICAL_NOTES_CATEGORIES_API = '/api/v1/note_categories';

@withRouter
@inject('clinicalNoteWritingCategoriesStore')
@observer
class ClinicalNotesWritingCategories extends Component {
  constructor(props) {
    super(props);
    this.state = {
      totalPages: 1,
    };
  }

  componentDidMount() {
    const { clinicalNoteWritingCategoriesStore } = this.props;

    new HttpClient().get(`${CLINICAL_NOTES_CATEGORIES_API}?page=1&per_page=10`)
    .then(({ body }) => {
      clinicalNoteWritingCategoriesStore.setCategories(body.data.note_category);

      this.setState({
        totalPages: body.data.total_pages,
      });
    })
  }

  nextPage = page => {
    const { clinicalNoteWritingCategoriesStore } = this.props;

    new HttpClient().get(`${CLINICAL_NOTES_CATEGORIES_API}?page=${page.selected + 1}&per_page=10`).then(({body}) => {
      clinicalNoteWritingCategoriesStore.setCategories(body.data.note_category);

      this.setState({
        totalPages: body.data.total_pages,
      });
      window.scrollTo({top: 0});
    });
  };

  render() {
    const { clinicalNoteWritingCategoriesStore: { categories } } = this.props;
    const { totalPages } = this.state;

    return (
      <PageWrapper>
        <div className="page-container">
          <h2>Categories</h2>
        </div>
        <Link to='/clinical-notes-writing/add'>+ Add New Category</Link>
        <div className="row">
          <div className="container">
            <div className="mcq-questions-list">
              {categories.length > 0 ? categories.map((category) => (
                <Link
                  to={`/clinical-notes-writing/${category.id}/edit`}
                  key={`note_category_${category.id}`}
                >
                  {category.title}
                </Link>
              )) : (
                <div className="empty-list-container">
                  <span className="self-center">There is no categories</span>
                </div>
              )}
            </div>
          </div>
        </div>
        <div className="pagination-container">
          <ReactPaginate
            containerClassName="react-paginate"
            pageCount={totalPages}
            onPageChange={this.nextPage}
          />
        </div>
      </PageWrapper>
    );
  }
};

export default ClinicalNotesWritingCategories;



// WEBPACK FOOTER //
// ./src/modules/admin/clinicalNoteWriting/containers/Categories.js